module.exports = __webpack_public_path__ + "img/prize6.db0cfa7d.jpg";